/** Map values into a hashtable */
export const mapObject = <T>(
  array: T[],
  callback: (value: T) => string
): Record<string, T> => {
  return array.reduce(
    (map, value) => {
      map[callback(value)] = value;
      return map;
    },
    Object.create(null) as Record<string, T>
  );
};

/** Group values into arrays mapped in a hashtable */
export const groupBy = <T>(
  array: T[],
  callback: (value: T) => string
): Record<string, T[]> => {
  return array.reduce(
    (map, value) => {
      (map[callback(value)] ??= []).push(value);
      return map;
    },
    Object.create(null) as Record<string, T[]>
  );
};
